"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Img = exports.ImgBlock = exports.ImgWrap = void 0;

var _react = _interopRequireWildcard(require("react"));

var _img = require("./img.styled");

var _imgContext = require("./img-context");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ImgWrap = function ImgWrap(props) {
  var src = props.src,
      height = props.height,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'No Image' : _props$placeholder,
      rest = _objectWithoutProperties(props, ["src", "height", "placeholder"]);

  var contextProps = (0, _react.useContext)(_imgContext.ImgContext);
  return /*#__PURE__*/_react.default.createElement(_img.ImgWrapStyled, {
    height: height,
    src: src
  }, src ? /*#__PURE__*/_react.default.createElement(_img.ImgStyled, _extends({}, rest, {
    src: src,
    heightContext: contextProps.height
  })) : placeholder);
};

exports.ImgWrap = ImgWrap;

var ImgBlock = function ImgBlock(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_img.ImgBlockStyled, null, children);
};

exports.ImgBlock = ImgBlock;

var Img = function Img(props) {
  var placeholder = props.placeholder,
      children = props.children,
      rest = _objectWithoutProperties(props, ["placeholder", "children"]);

  return /*#__PURE__*/_react.default.createElement(_imgContext.ImgContext.Provider, {
    value: props
  }, children ? /*#__PURE__*/_react.default.createElement(ImgBlock, null, placeholder ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ImgWrap, rest), children) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_img.ImgStyled, rest), children)) : placeholder ? /*#__PURE__*/_react.default.createElement(ImgWrap, rest) : /*#__PURE__*/_react.default.createElement(_img.ImgStyled, rest));
};

exports.Img = Img;
Img.defaultProps = {
  bg: 'transparent'
};
Img.displayName = 'Img';
Img.Style = _img.ImgStyled;